import type { AxiosResponseHeaders, AxiosResponseTransformer } from 'axios'
import camelcaseKeys from 'camelcase-keys'

export const toCamelcase: AxiosResponseTransformer = (data: string, headers: AxiosResponseHeaders) => {
  if (data && headers['content-type']?.includes('application/json')) {
    return camelcaseKeys(JSON.parse(data) as Record<string, unknown>, {
      deep: true,
    })
  }
}
